function CurrencyConvert(value) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: countryCode,
        minimumFractionDigits: 2
    });
    return formatter.format(value);
};
var one_day = 1000 * 60 * 60 * 24;
$(document).ready(function () {
    $('.shogun-product-card').each(function () {
        var productId = $(this).attr('data-id');

        var lowest_price = Number.MAX_VALUE;
        var lowest_compare_at_price = null;
        var lowest_price_variant_id = '';
        $(this).find('.variant-data-entry').each(function () {
            if (countryCode.indexOf($(this).attr('data-option-1')) != -1 || countryCode.indexOf($(this).attr('data-option-2')) != -1 || countryCode.indexOf($(this).attr('data-option-3')) != -1) {
                var price = parseFloat($(this).attr('data-price'));
                if (price < lowest_price) {
                    lowest_price = price;
                    lowest_compare_at_price = $(this).attr('data-compare-at-price').length ? parseFloat($(this).attr('data-compare-at-price')) : null;
                    lowest_price_variant_id = $(this).attr('data-id');
                }
            }
        });
        if (lowest_compare_at_price == null || lowest_compare_at_price == lowest_price) {
            $(this).find('.price--compare').hide();
        } else {
            $(this).find('.price--compare').html(CurrencyConvert(lowest_compare_at_price));
        }
        $(this).find('.price--sell').html(CurrencyConvert(lowest_price));
        $(this).find('.product-card__image-wrapper').append('<span class="smartwishlist" data-product="' + productId + '" data-variant="' + lowest_price_variant_id + '"></span>');
        var self = this;
        $.ajax({
            type: 'GET',
            url: '/products/' + $(self).attr('data-handle') + '.json',
            success: function (response) {
                var product = response.product;
                if (!product.available) {
                    $(self).addClass('product-card--sold-out');
                }
                if (product.price_varies) {
                    $(self).find('.product-card-from').show();
                }
                
                var published = product.published_at;
                var difference_in_time = (new Date()).getTime() - (new Date(published)).getTime();
                var days_old = difference_in_time / one_day;
                if (lowest_compare_at_price != null && lowest_compare_at_price > lowest_price) {
                    var percentDisplay = Math.floor((1.00 - (lowest_price / lowest_compare_at_price)) * 100.00) + '% off';
                    $(self).find('.percent-badge').html(percentDisplay);
                    $(self).find('.percent-badge').show();
                } else if (days_old <= 30){
                    $(self).find('.new-badge').show();
                } else if ($(self).attr('data-tags').toLowerCase().indexOf('bestseller') != -1) {
                    $(self).find('.bestseller-badge').show();
                }
            }
        });
    });
});